import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoujjainacab() {



    const cardData = {

keyword: "Pune to Ujjain Cab",

headingDescription:
    "Rising Cab Service offers reliable and comfortable Pune to Ujjain Cab services for pilgrims, families, tourists, and business travelers. We provide Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles for one-way and round-trip journeys with experienced chauffeurs. Our service includes doorstep pickup, 24/7 booking support, transparent pricing, and well-maintained vehicles, ensuring a safe and hassle-free journey from Pune to the holy city of Ujjain.",

topPlaces: [
    {
        title: "Shri Mahakaleshwar Jyotirlinga Temple",
        description:
            "Shri Mahakaleshwar Temple is one of the twelve sacred Jyotirlingas of Lord Shiva and the most important pilgrimage destination in Ujjain. The temple is famous for its unique south-facing Shiva Lingam and the early morning Bhasma Aarti, which attracts thousands of devotees every day. The grand architecture, spiritual atmosphere, and historical significance make it one of India's most revered temples. During Mahashivratri and the Simhastha Kumbh Mela, the temple becomes a major center of religious celebrations."
    },
    {
        title: "Kal Bhairav Temple",
        description:
            "Kal Bhairav Temple is one of the oldest and most unique temples in Ujjain, dedicated to Lord Kal Bhairav, a fierce form of Lord Shiva. The temple is famous for the ritual of offering sacred liquor to the deity, a tradition that fascinates pilgrims and tourists alike. Surrounded by ancient legends and spiritual importance, the temple is considered an essential stop during a visit to Ujjain."
    },
    {
        title: "Harsiddhi Temple",
        description:
            "Harsiddhi Temple is one of the revered Shakti Peethas in India and is dedicated to Goddess Harsiddhi. The temple is especially known for its two massive oil lamps that are beautifully illuminated during festivals and Navratri celebrations. Its ancient architecture, peaceful environment, and religious significance attract devotees seeking blessings and spiritual peace."
    },
    {
        title: "Ram Ghat",
        description:
            "Ram Ghat is the most famous bathing ghat on the banks of the sacred Shipra River and plays a vital role during the Simhastha Kumbh Mela. Pilgrims gather here to take holy dips and perform religious rituals throughout the year. The evening aarti performed on the riverbank creates a divine atmosphere, making it one of the most visited spiritual places in Ujjain."
    },
    {
        title: "Sandipani Ashram",
        description:
            "Sandipani Ashram is believed to be the place where Lord Krishna, Balarama, and Sudama received their education under Guru Sandipani. The ashram is an important religious and historical site featuring ancient temples, sacred ponds, and peaceful surroundings. Visitors come to learn about its connection with Hindu mythology and experience its spiritual ambiance."
    },
    {
        title: "Mangalnath Temple",
        description:
            "Mangalnath Temple is dedicated to Lord Shiva and is believed to be the birthplace of the planet Mars according to Hindu astronomy. Devotees visit the temple to perform special rituals for Mangal Dosha and seek prosperity and success. Located on the banks of the Shipra River, the temple also offers beautiful views and a serene atmosphere."
    },
    {
        title: "Chintaman Ganesh Temple",
        description:
            "Chintaman Ganesh Temple is one of the oldest Ganesh temples in Madhya Pradesh and is highly revered by devotees. The self-manifested idol of Lord Ganesha is believed to fulfill the wishes of worshippers and remove obstacles from their lives. The temple's ancient architecture and spiritual significance make it an important pilgrimage destination."
    },
    {
        title: "Bhartrihari Caves",
        description:
            "Bhartrihari Caves are ancient rock caves associated with the legendary poet and philosopher Bhartrihari, who is believed to have meditated here. The caves have historical and spiritual importance and offer visitors a glimpse into ancient ascetic traditions. Their peaceful surroundings make them an interesting attraction for history and spirituality enthusiasts."
    },
    {
        title: "Vedh Shala (Jantar Mantar)",
        description:
            "Vedh Shala is an ancient astronomical observatory built by Maharaja Jai Singh II and showcases India's scientific and astronomical heritage. The observatory contains several instruments used to study celestial movements and time calculations. It attracts students, researchers, and tourists interested in astronomy and history."
    },
    {
        title: "ISKCON Ujjain Temple",
        description:
            "ISKCON Ujjain Temple is a beautiful spiritual center dedicated to Lord Krishna and Radha. The temple is known for its peaceful atmosphere, devotional music, cultural activities, and beautifully decorated idols. Visitors can participate in prayers, festivals, and spiritual programs while experiencing the rich traditions of the ISKCON movement."
    }
],



services: [
{
    name: "Pune to Ujjain Cab",
    description: "Rising Cab Service offers Pune to Ujjain Cab with safe, comfortable, and affordable outstation travel for families, pilgrims, business travelers, and tourists. Our service includes one-way and round-trip bookings with experienced drivers, clean AC vehicles, and 24x7 customer support. Choose from Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and Force Urbania for a comfortable journey to Ujjain and other destinations across Madhya Pradesh."
},
{
    name: "Pune to Ujjain Cab Service",
    description: "Book Pune to Ujjain Cab Service with Rising Cab Service for reliable long-distance travel. We provide doorstep pickup, professional chauffeurs, transparent pricing, and well-maintained vehicles for safe and hassle-free intercity transportation."
},
{
    name: "Pune to Ujjain Taxi Service",
    description: "Our Pune to Ujjain Taxi Service is ideal for Mahakal Darshan, family tours, business trips, and holiday travel. Enjoy flexible travel schedules, comfortable vehicles, and dependable service throughout the journey."
},
{
    name: "Pune to Ujjain Cab Booking",
    description: "Rising Cab Service provides easy Pune to Ujjain Cab Booking with instant confirmation, multiple vehicle options, and affordable pricing for one-way and round-trip travel."
},
{
    name: "Best Pune to Ujjain Cab",
    description: "Best Pune to Ujjain Cab offers premium travel quality with experienced drivers, spacious vehicles, and reliable customer service for safe and comfortable long-distance journeys."
},
{
    name: "One Way Pune to Ujjain Cab",
    description: "One Way Pune to Ujjain Cab provides economical single-trip travel with clean AC vehicles, professional drivers, and transparent pricing for convenient outstation transportation."
},
{
    name: "Round Trip Pune to Ujjain Taxi",
    description: "Book Round Trip Pune to Ujjain Taxi with flexible return schedules, waiting options, and comfortable vehicles for pilgrimage, family, and business travel."
},
{
    name: "Cheap Pune to Ujjain Cab",
    description: "Cheap Pune to Ujjain Cab offers budget-friendly long-distance travel without compromising safety, comfort, or service quality."
},
{
    name: "24x7 Pune to Ujjain Cab Service",
    description: "Rising Cab Service provides 24x7 Pune to Ujjain Cab Service with round-the-clock availability, instant booking assistance, and reliable transportation."
},
{
    name: "Outstation Cab Pune to Ujjain",
    description: "Outstation Cab Pune to Ujjain ensures comfortable highway travel with professional drivers, AC vehicles, and customized travel plans."
},
{
    name: "Pune to Indore Taxi",
    description: "Book Pune to Indore Taxi with Rising Cab Service for affordable and comfortable intercity travel with one-way and round-trip options."
},
{
    name: "Pune to Bhopal Taxi",
    description: "Pune to Bhopal Taxi offers safe long-distance transportation with experienced drivers, transparent fares, and comfortable AC vehicles."
},
{
    name: "Pune to Gwalior Cab Booking",
    description: "Rising Cab Service provides Pune to Gwalior Cab Booking with quick reservations, professional chauffeurs, and reliable outstation travel."
},
{
    name: "Pune to Jabalpur Taxi",
    description: "Pune to Jabalpur Taxi ensures smooth and comfortable travel for business trips, family vacations, and long-distance journeys."
},
{
    name: "Pune to Ujjain Outstation Cab",
    description: "Pune to Ujjain Outstation Cab provides flexible travel options with doorstep pickup, safe driving, and comfortable vehicles."
},
{
    name: "Pune to Indore Innova Crysta",
    description: "Pune to Indore Innova Crysta offers premium group travel with spacious seating, luxury interiors, and professional drivers."
},
{
    name: "Pune to Bhopal Tempo Traveller",
    description: "Pune to Bhopal Tempo Traveller is ideal for family groups, corporate travel, and pilgrimage tours with spacious seating and modern amenities."
},
{
    name: "Pune to Ujjain Urbania",
    description: "Book Pune to Ujjain Urbania for luxury group travel with premium seating, ample luggage space, and comfortable long-distance transportation."
},
{
    name: "Luxury Cab Pune Madhya Pradesh",
    description: "Luxury Cab Pune Madhya Pradesh offers premium outstation travel with high-end vehicles, professional chauffeurs, and personalized travel experiences."
},
{
    name: "Best Pune to Indore Cab Service",
    description: "Best Pune to Indore Cab Service provides safe, affordable, and comfortable travel with well-maintained vehicles and experienced drivers."
},
{
    name: "Cheap Pune to Bhopal Taxi",
    description: "Cheap Pune to Bhopal Taxi offers economical travel options with transparent pricing and reliable transportation services."
},
{
    name: "Book Pune to Ujjain Cab Online",
    description: "Book Pune to Ujjain Cab Online for instant confirmation, multiple vehicle choices, and convenient outstation travel planning."
},
{
    name: "One Way Taxi Pune to Gwalior",
    description: "One Way Taxi Pune to Gwalior provides affordable single-trip travel with comfortable AC vehicles and experienced drivers."
},
{
    name: "Tempo Traveller Pune to Jabalpur",
    description: "Tempo Traveller Pune to Jabalpur is perfect for family tours, pilgrimage groups, and corporate outings with spacious seating and comfortable travel."
},
{
    name: "Urbania on Rent Pune to Indore",
    description: "Urbania on Rent Pune to Indore offers luxury group transportation with premium interiors, comfortable seating, and professional chauffeurs."
},
{
    name: "Family Cab Pune to Ujjain",
    description: "Family Cab Pune to Ujjain provides safe and spacious travel solutions for family vacations and religious tours with comfortable vehicles."
},
{
    name: "Luxury Taxi Pune Madhya Pradesh",
    description: "Luxury Taxi Pune Madhya Pradesh offers premium long-distance travel with luxury vehicles and personalized service."
},
{
    name: "Affordable Pune to Indore Cab Service",
    description: "Affordable Pune to Indore Cab Service combines budget-friendly pricing with safe, reliable, and comfortable intercity transportation."
},
{
    name: "Pune to Ujjain Innova Crysta on Rent",
    description: "Pune to Ujjain Innova Crysta on Rent provides premium family and group travel with spacious seating and luxury comfort."
},
{
    name: "Luxury Tempo Traveller Pune Bhopal",
    description: "Luxury Tempo Traveller Pune Bhopal is ideal for large groups seeking premium travel comfort and safe long-distance transportation."
},
{
    name: "Force Urbania Pune to Indore",
    description: "Force Urbania Pune to Indore offers luxury group travel with premium seating, advanced safety features, and comfortable long-distance journeys."
}
],

tableData: [
["Pune to Ujjain Cab","Pune to Ujjain Cab Service"],
["Pune to Ujjain Taxi Service","Pune to Ujjain Cab Booking"],
["Best Pune to Ujjain Cab","One Way Pune to Ujjain Cab"],
["Round Trip Pune to Ujjain Taxi","Cheap Pune to Ujjain Cab"],
["24x7 Pune to Ujjain Cab Service","Outstation Cab Pune to Ujjain"],
["Pune to Indore Taxi","Pune to Bhopal Taxi"],
["Pune to Gwalior Cab Booking","Pune to Jabalpur Taxi"],
["Pune to Ujjain Outstation Cab","Pune to Indore Innova Crysta"],
["Pune to Bhopal Tempo Traveller","Pune to Ujjain Urbania"],
["Luxury Cab Pune Madhya Pradesh","Best Pune to Indore Cab Service"],
["Cheap Pune to Bhopal Taxi","Book Pune to Ujjain Cab Online"],
["One Way Taxi Pune to Gwalior","Tempo Traveller Pune to Jabalpur"],
["Urbania on Rent Pune to Indore","Family Cab Pune to Ujjain"],
["Luxury Taxi Pune Madhya Pradesh","Affordable Pune to Indore Cab Service"],
["Pune to Ujjain Innova Crysta on Rent","Luxury Tempo Traveller Pune Bhopal"],
["Force Urbania Pune to Indore","Pune to Ujjain Cab"]
],




whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Ujjain Cab Service",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Ujjain cab transportation for pilgrims, families, tourists, and business travelers seeking a comfortable long-distance journey."
    },
    {
        WhyChooseheading: "Perfect for Mahakaleshwar Jyotirlinga Darshan",
        WhyChoosedescription: "Thousands of devotees choose our cab service to visit the sacred Mahakaleshwar Jyotirlinga Temple and other important spiritual destinations in Ujjain."
    },
    {
        WhyChooseheading: "Suitable for Religious and Family Tours",
        WhyChoosedescription: "Whether planning a pilgrimage, family vacation, spiritual retreat, or cultural trip, we provide travel solutions designed for every requirement."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Travelers can select Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to group size and comfort preferences."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Packages Available",
        WhyChoosedescription: "Customers can choose one-way travel, return journeys, multi-day tours, or customized Ujjain pilgrimage packages."
    },
    {
        WhyChooseheading: "Pickup from Any Pune Location",
        WhyChoosedescription: "Doorstep pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and surrounding Pune areas."
    },
    {
        WhyChooseheading: "Visit Nearby Sacred Destinations",
        WhyChoosedescription: "Travel plans can include Omkareshwar Jyotirlinga, Indore, Kal Bhairav Temple, Harsiddhi Mata Temple, Ram Ghat, and other important attractions."
    },
    {
        WhyChooseheading: "Experienced Drivers for Interstate Travel",
        WhyChoosedescription: "Our professional drivers are experienced with Maharashtra and Madhya Pradesh routes, ensuring safe and comfortable travel throughout the journey."
    }
]
};

const faqData = [
    {
        question: "Why is Ujjain one of the most visited pilgrimage destinations in India?",
        answer: "Ujjain is home to the famous Mahakaleshwar Jyotirlinga and is considered one of the seven sacred cities in Hinduism."
    },
    {
        question: "Can I book a one-way cab from Pune to Ujjain?",
        answer: "Yes, one-way taxi services are available along with round-trip and customized pilgrimage packages."
    },
    {
        question: "Which temples can be visited in Ujjain?",
        answer: "Popular temples include Mahakaleshwar Jyotirlinga, Kal Bhairav Temple, Harsiddhi Mata Temple, Chintaman Ganesh Temple, and Mangalnath Temple."
    },
    {
        question: "Can Omkareshwar be included in the travel itinerary?",
        answer: "Yes, many devotees combine Ujjain and Omkareshwar Jyotirlinga Darshan in a single pilgrimage tour."
    },
    {
        question: "Which vehicle is best for a family pilgrimage trip?",
        answer: "Ertiga and Innova Crysta are popular choices because they offer spacious seating and excellent travel comfort."
    },
    {
        question: "Do you provide Tempo Travellers for religious groups?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for pilgrimage groups, family tours, and spiritual organizations."
    },
    {
        question: "Can travelers visit Indore during the trip?",
        answer: "Yes, customized travel plans can include Indore sightseeing, shopping, food tours, and nearby attractions."
    },
    {
        question: "Are multi-day Ujjain tour packages available?",
        answer: "Yes, customers can book customized multi-day pilgrimage and sightseeing packages according to their schedule."
    },
    {
        question: "Can the journey start from Pune Airport or Railway Station?",
        answer: "Yes, pickups are available from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I reserve a Pune to Ujjain Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Vinod Sharma",
        feedback:
            "Our Mahakaleshwar Darshan trip was planned beautifully. The vehicle was comfortable, the driver was cooperative, and the entire pilgrimage experience was peaceful and memorable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Archana Kulkarni",
        feedback:
            "We visited both Ujjain and Omkareshwar with our family. The travel arrangements were excellent, and the journey remained comfortable throughout the tour.",
        rating: 5
    }
];

    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Ujjain Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-ujjain-cab.jpg",
"description": "Book Pune to Ujjain Cab Service with Rising Cab Service for safe, comfortable, and spiritual travel. Enjoy reliable one-way and round-trip outstation taxi service with AC sedans, SUVs, and Innova cars at affordable prices.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-ujjain-cab"
}
};







    return (
        <div>

<Helmet>
  <title>Pune to Ujjain Cab Service | One Way & Round Trip Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Ujjain Cab Service for safe, comfortable, and spiritual outstation travel. Get reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars at affordable prices."
/>

<meta
 name="keywords"
 content="Pune to Ujjain Cab, Pune to Ujjain Cab Service, Pune to Ujjain Taxi Service, Pune to Ujjain Cab Booking, Best Pune to Ujjain Cab, One Way Pune to Ujjain Cab, Round Trip Pune to Ujjain Taxi, Cheap Pune to Ujjain Cab, 24x7 Pune to Ujjain Cab Service, Outstation Cab Pune to Ujjain, Pune to Indore taxi, Pune to Bhopal taxi, Pune to Gwalior cab booking, Pune to Jabalpur taxi, Pune to Ujjain outstation cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/50.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoujjainacab;